export default IconArrowUpFromArc => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-up-from-arc" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 9v12" />
  <path d="M8 17l4 4l4 -4" />
  <path d="M21 12a9 9 0 0 0 -18 0" />
</svg>`;